import { AppSyncLoc } from './app_sync_loc.js';
import { AppSyncTrip } from './app_sync_trip.js';

class AppSync {
  get syncLoc() {
    if (!this.#syncLoc) {
      this.#syncLoc = new AppSyncLoc();
    }
    return this.#syncLoc;
  }

  get syncTrip() {
    if (!this.#syncTrip) {
      this.#syncTrip = new AppSyncTrip();
    }
    return this.#syncTrip;
  }

  shutdown() {
    this.#syncLoc?.shutdown();
    this.#syncTrip?.shutdown();
  }

  #syncLoc;
  #syncTrip;
}

export const appSync = new AppSync();
